import { Season } from "../seasons/seasonReducer";
import { fetchGet, fetchPost } from "../util/apiUtil";

export const loadSeasons = () => fetchGet("Seasons/GetAll");
export const createSeason = (name: string) =>
  fetchPost("Seasons/Create", { name });
export const updateSeason = (season: Season) =>
  fetchPost("Seasons/Update", season);
